// This is being used for the project info modal in the data reports user assignments page
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "content"]

  open(event) {
    event.preventDefault();
    const el = event.currentTarget;
    
    // Show modal overlay
    if (this.hasModalTarget) this.modalTarget.classList.remove("hidden");
    
    // Completely destroy and recreate the turbo frame
    const oldFrame = document.getElementById("project_info_modal");
    if (oldFrame) {
      oldFrame.remove();
    }
    
    // Create new turbo frame
    const newFrame = document.createElement("turbo-frame");
    newFrame.id = "project_info_modal";
    newFrame.innerHTML = `<div data-project-info-modal-target="content" class="space-y-4">Loading...</div>`;
    
    // Find the container and append the new frame
    // We need to find the specific modal's container, not just any .p-6 container
    const modalContainer = this.modalTarget.querySelector('.p-6.overflow-y-auto');
    if (modalContainer) {
      modalContainer.appendChild(newFrame);
    }
    
    // Build params and set src
    const projectId = el.dataset.projectInfoModalProjectId;
    const params = new URLSearchParams({
      project_id: projectId,
      _ts: Date.now()
    });
    
    // Set src to trigger request
    newFrame.setAttribute("src", `/data_reports/project_info_modal?${params.toString()}`);
  }

  close(event) {
    if (event) event.preventDefault()
    this.modalTarget.classList.add("hidden")
    // Clear Turbo Frame content and src for next open
    const turboFrame = document.getElementById("project_info_modal")
    if (turboFrame) {
      turboFrame.removeAttribute("src")
      turboFrame.innerHTML = `<div data-project-info-modal-target="content" class="space-y-4"></div>`
    }
  }
}